module.exports = __webpack_public_path__ + "f66931e863eedd6094402640db25a8ad.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/br.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/br.svg
// module chunks = 0